import Vue from 'vue'
import RootTableMixin from 'GroomyRoot/mixins/Table.js'
import Constants from 'Constants'

export default Vue.util.mergeOptions(RootTableMixin, {

    methods: {
		generateTableConfigShareLink: async function(config_id) {
			const url = this.constructRoute(Constants.TABLE_SHARE_URL, {config_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_post_api("TableMixin::generateTableConfigShareLink", url, {})
			if(result) return result.retour
			return null
		},

		getShareConfig: async function(config_id) {
			const url = this.constructRoute(Constants.TABLE_SHARE_URL, {config_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_get_api("TableMixin::getShareConfig", url)
			if(result) return result.retour
			return null
		},

		checkInvoiceSupplierBalance: function(item) {
			return item[0].suppliersocr_balance !== 0
		},

		checkInvoiceSupplierOCR: function(item) {
			return item[0].suppliersocr_ocr_status !== 'waiting'
		},

		checkInvoiceSupplierSameTiers: function(items) {
			return items.every(i => i.suppliersocr_tiers === items[0].suppliersocr_tiers && i.suppliersocr_entity === items[0].suppliersocr_entity)
		},

		checkInvoiceSupplierSolde: function(item) {
			return item[0].suppliersocr_balance == item[0].suppliersocr_ttc
		},

		checkInvoiceSupplierExportReady: function(item) {
			return item[0].suppliersocr_export_status == 'ready' || item[0].suppliersocr_export_status == 'exported'
		},

		checkIfIntraLocalation: function(item) {
			return !item[0].lieu
		},

		checkIfAccountingAccountSupplier: function(item) {
			return item[0].accountingplan_supplier
		},

		isInLocalisationResidence() {
            return this.$route.name === 'localisationResidence'
        },

		checkStatusCancelExpedition: function(items) {
			return items.every(item => [1,2,3].includes(item.semenceexpedition_status))
		},

		checkStatusPrepareExpedition: function(items) {
			return items.every(item => item.semenceexpedition_status == 2)
		},

		checkStatusPretExpedition: function(items) {
			let nb_doses = items.filter(item => item.semenceexpedition_dose)
			return items.every(item => item.semenceexpedition_status == 3 && items[0].semenceexpedition_destinataire == item.semenceexpedition_destinataire) && (nb_doses.length == 0 || nb_doses.length == items.length)
		},

		checkStatusEnregistree: function(items) {
			return items.every(item => item.semenceexpedition_status == 1)
		},

		checkStatusDiffereExpedition: function(items) {
			return items.every(item => item.semenceexpedition_status == 3)
		},

		checkStatusReintegrerExpedition: function(items) {
			let nb_doses = items.filter(item => item.semenceexpedition_dose)
			return items.every(item => item.semenceexpedition_status == 4 && items[0].semenceexpedition_cuve == item.semenceexpedition_cuve) && (nb_doses.length == 0 || nb_doses.length == items.length)
		},

		checkLotInventoried: function(items) {
			return items.every(item => item.has_emplacements)
		},

		checkLotsNotInventoried: function(items) {
			return items.every(item => !item.has_emplacements)
		},

		checkLotsNotInventoriedOrPrestock: function(items) {
			return items.every(item => !item.has_emplacements || item.emplacement_prestockage)
		},

		checkStatusExpeditionEditable: function(items) {
			return [1,2,3].includes(items[0].semenceexpedition_status)
		},

		checkStatusConfirmExpedition: function(items) {
			return items.every(item => item.semenceexpedition_status == 5)
		},

		checkStatusExpeditionUninvoiceable: function(items) {
			return [5,6,7].includes(items[0].semenceexpedition_status)
		},

		checkInvoiceFixed: function(items) {
			return items.every(item => new Date(item.invoice_date) <= new Date())
		}
	}
})